import { MIN, S } from 'dayjs/esm/constant'

const QH = 'quarterhour'

export default (o, c) => {
	const proto = c.prototype

	proto.quarterHour = function (quarterHour) {
		if (!this.$utils().u(quarterHour)) {
			return this.minute((this.minute() % 15) + ((quarterHour - 1) * 15))
		}

		return Math.ceil((this.minute() + 1) / 15)
	}

	const oldAdd = proto.add
	proto.add = function (number, units) {
		number = Number(number) // eslint-disable-line no-param-reassign

		const unit = this.$utils().p(units)

		if (unit === QH) {
			return this.add(number * 15, MIN)
		}

		return oldAdd.bind(this)(number, units)
	}

	const oldStartOf = proto.startOf
	proto.startOf = function (units, startOf) {
		const utils = this.$utils()
		const isStartOf = !utils.u(startOf) ? startOf : true
		const unit = utils.p(units)

		if (unit === QH) {
			const quarterHour = this.quarterHour() - 1

			return isStartOf
				? this.minute(quarterHour * 15).startOf(MIN)
				: this.minute((quarterHour * 15) + 14).endOf(MIN).endOf(S)
		}

		return oldStartOf.bind(this)(units, startOf)
	}
}
